export default __webpack_public_path__ + "static/media/trackerApi.8ac3b1cd.png";